import {Box} from '@mui/material';
import {alpha} from '@mui/material/styles';
import PropTypes from 'prop-types';

import {mapApiParameterTypeToIcon} from '../form/ui';

const ApiParameterTypeIcon = ({type}) => {
  const {Icon} = mapApiParameterTypeToIcon(type);

  return (
    <Box
      sx={theme => {
        return {
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          px: 1.4,
          py: 1.2,
          borderRadius: 3,
          backgroundColor: alpha(theme.palette.primary.main, 0.12),
          mr: 1
        };
      }}
    >
      <Icon
        sx={theme => ({
          fontSize: 20,
          color: theme.palette.primary.main
        })}
      />
    </Box>
  );
};

ApiParameterTypeIcon.propTypes = {
  type: PropTypes.string.isRequired
};

export default ApiParameterTypeIcon;
